const workExperienceEmployedPaths = courseType => {
  const prefix = `Experienced${courseType}`;
  return [
    {
      url: '/current-salary',
      sec: '5',
      name: `${prefix}CurrentSalary`,
      zendeskSuggestions: ['contextual: onboarding_salary'],
    },
    {
      url: '/employer',
      sec: '5',
      name: `${prefix}Employer`,
      zendeskSuggestions: ['contextual: onboarding_employer'],
    },
    {
      url: '/employer-country',
      selector: 'currentlyEmployedAndPartTimeSelector',
      sec: '5',
      name: `${prefix}EmployerCountry`,
      true: [
        {
          url: '/full-time-employment-dates',
          sec: '5',
          name: `${prefix}FullTimeEmploymentDates`,
        },
      ],
      false: [
        {
          url: '/employment-dates',
          sec: '5',
          name: `${prefix}EmploymentDates`,
        },
        ...confirmedJobOfferPaths(),
      ],
    },
  ];
};

const confirmedJobOfferPaths = () => {
  return [
    {
      url: '/confirmed-job-offer',
      selector: 'hasConfirmedJobOfferSelector',
      sec: '5',
      name: 'ConfirmedJobOffer',
      true: [
        {
          url: '/future-salary',
          sec: '5',
          name: 'FutureSalary',
          zendeskSuggestions: ['contextual: onboarding_future_income'],
        },
      ],
      false: [],
      stateItemsToReset: [
        'futureSalaryAmount',
        'futureSalaryType',
        'futureSalaryAmount',
        'futureSalaryCurrency',
      ],
    },
  ];
};

const missingPeriodsDataPath = () => {
  return [
    {
      url: '/programme-length',
      sec: '1',
      name: 'ProgrammeLength',
      zendeskSuggestions: ['contextual: onboarding_course'],
    },
    {
      url: '/programme-costs',
      sec: '1',
      name: 'ProgrammeCosts',
      zendeskSuggestions: ['contextual: onboarding_course'],
    },
    {
      url: '/period-request',
      sec: '1',
      name: 'PeriodRequest',
      zendeskSuggestions: ['contextual: onboarding_period'],
      selector: 'currentPeriodSelector',
      true: [
        {
          url: '/unpaid-tuition-cost',
          sec: '1',
          name: 'UnpaidTuitionCost',
          zendeskSuggestions: ['contextual: onboarding_period'],
        },
      ],
      false: [],
    },
  ];
};

const workExperienceUnemployedAndFullTimeCoursePaths = prefix => {
  return [
    {
      url: '/employer',
      sec: '5',
      name: 'Employer',
      zendeskSuggestions: ['contextual: onboarding_employer'],
    },
    {
      url: '/employer-country',
      sec: '5',
      name: 'EmployerCountry',
    },
    {
      url: '/employment-dates',
      sec: '5',
      name: 'EmployerDates',
    },
    ...confirmedJobOfferPaths(),
  ];
};

const wizardConfig = [
  { url: '/', sec: '0', name: 'Root', zendeskSuggestions: ['contextual: onboarding_welcome'] },
  {
    url: '/referral-code',
    sec: '1',
    name: 'ReferralCode',
    zendeskSuggestions: ['contextual: onboarding_referral_code'],
  },
  {
    url: '/date-of-birth',
    sec: '1',
    name: 'DateOfBirth',
    type: 'create',
    zendeskSuggestions: ['contextual: onboarding_date_of_birth'],
  },
  {
    url: '/previous-residence',
    sec: '1',
    name: 'PreviousResidence',
    zendeskSuggestions: ['contextual: onboarding_residential_history'],
  },
  {
    url: '/citizenship',
    sec: '1',
    name: 'Citizenship',
    zendeskSuggestions: ['contextual: onboarding_citizenship'],
  },
  {
    url: '/habitual-residence',
    sec: '1',
    name: 'HabitualResidence',
    zendeskSuggestions: ['contextual: onboarding_residential_history'],
    stateItemsToReset: [
      'periods',
      'period',
      'periodsTimeStamp',
      'course',
      'courseGuid',
      'coursePeriodGuid',
      'periodStartDate',
      'partTimeCourse',
    ],
  },
  {
    url: '/where-to-study',
    sec: '1',
    name: 'WhereToStudy',
    zendeksSuggestions: ['contextual: onboarding_where_to_study'],
    selector: 'schoolSelector',
    underReview: [
      {
        url: '/course-under-review',
        sec: '1',
        name: 'CourseUnderReview',
        zendeskSuggestions: ['contextual: onboarding_course'],
      },
    ],
    invalidCourse: [
      {
        url: '/class-under-review',
        sec: '1',
        name: 'ClassUnderReview',
      },
    ],
    fullTimeCourse: [],
    notFullTimeCourse: [{ url: '/full-time-job', sec: '1', name: 'FullTimeJob' }],
    unvalidatedPeriodsData: [...missingPeriodsDataPath()],
    // we may no longer need this?
    supportedCourse: [],
    unsupportedSchool: [
      {
        url: '/unsupported-school',
        sec: '1',
        name: 'UnsupportedSchool',
        zendeskSuggestions: ['contextual: onboarding_school'],
      },
      {
        url: '/study-start-date-submitted',
        sec: '1',
        name: 'StudyStartDateSubmitted',
        zendeskSuggestions: ['contextual: onboarding_school'],
      },
    ],
    frenchRegulationBlockedSchool: [
      {
        url: '/french-regulation-block',
        sec: '1',
        name: 'FrenchRegulationBlockSchool',
        zendeskSuggestions: ['contextual: onboarding_school'],
      },
    ],
    singleCampus: [],
    multipleCampuses: [
      {
        url: '/campus',
        sec: '1',
        name: 'Campus',
        zendeskSuggestions: ['contextual: onboarding_school'],
        selector: 'blockedCampusSelector',
        false: [],
        true: [
          {
            url: '/french-regulation-block',
            sec: '1',
            name: 'FrenchRegulationBlockCampus',
            zendeskSuggestions: ['contextual: onboarding_school'],
          },
        ],
      },
    ],
  },

  {
    url: '/check-eligible',
    sec: '1',
    name: 'CheckEligible',
    selector: 'eligibleSelector',
    eligible: [{ url: '/eligible', sec: '1', name: 'Eligible' }],
    ineligible: [
      {
        url: '/ineligible',
        page: 'IneligiblePage',
        sec: '1',
        name: 'Ineligible',
        zendeskSuggestions: [
          'contextual: onboarding_ineligible_country',
          'contextual: onboarding_ineligible_state',
          'contextual: onboarding_ineligible_citizenship',
          'contextual: onboarding_ineligible_part_time',
        ],
      },
    ],
  },
  {
    url: '/passport-name',
    type: 'newSection',
    sec: '2',
    name: 'PassportName',
    zendeskSuggestions: ['contextual: onboarding_name'],
  },
  {
    url: '/current-address',
    sec: '2',
    name: 'CurrentAddress',
    zendeskSuggestions: ['contextual: onboarding_address'],
    selector: 'requiresExtraAddressesSelector',
    oneAddressNeeded: [],
    twoAddressesNeeded: [
      {
        url: '/second-address',
        sec: '2',
        name: 'SecondAddress',
        zendeskSuggestions: ['contextual: onboarding_second_address'],
      },
    ],
    threeAddressesNeeded: [
      {
        url: '/second-address',
        sec: '2',
        name: 'SecondAddress',
        zendeskSuggestions: ['contextual: onboarding_second_address'],
      },
      {
        url: '/third-address',
        sec: '2',
        name: 'ThirdAddress',
        zendeskSuggestions: ['contextual: onboarding_third_address'],
      },
    ],
  },
  {
    url: '/gender',
    sec: '2',
    name: 'Gender',
    zendeskSuggestions: ['contextual: onboarding_gender'],
  },
  {
    url: '/test-taken',
    sec: '2',
    name: 'TestTaken',
    zendeskSuggestions: ['contextual: onboarding_test_taken'],
  },
  {
    url: '/save-personal-info',
    type: 'save',
    sec: '2',
    name: 'SavePersonalInfo',
  },
  {
    url: '/estimated-assets',
    type: 'newSection',
    sec: '3',
    name: 'EstimatedAssets',
    zendeskSuggestions: ['contextual: onboarding_assets'],
  },
  {
    url: '/has-debt',
    sec: '3',
    name: 'HasDebt',
    zendeksSuggestions: ['contextual: onboarding_debt'],
  },
  {
    url: '/credit-card-debt',
    sec: '3',
    name: 'CreditCardDebt',
  },
  {
    url: '/save-personal-finances',
    type: 'save',
    sec: '3',
    name: 'SavePersonalFinances',
  },
  {
    url: '/previous-education',
    type: 'newSection',
    sec: '4',
    name: 'PreviousEducation',
    zendeskSuggestions: ['contextual: onboarding_previous_education'],
    stateItemsToReset: [
      'previousEducationUniversity',
      'previousEducationLevelOfDegree',
      'previousEducationFieldOfStudy',
      'previousEducationUniversityGuid',
      'previousEducationUniversityName',
    ],
  },
  {
    url: '/save-previous-education',
    type: 'save',
    sec: '4',
    name: 'SavePreviousEducation',
  },
  {
    url: '/work-experience',
    type: 'newSection',
    sec: '5',
    name: 'WorkExperience',
    zendeskSuggestion: ['contextual: onboarding_work_experience'],
    selector: 'workExperienceLevelSelector',
    partTimeCourse: [...workExperienceEmployedPaths('PartTime')],
    experiencedFullTime: [
      {
        url: '/currently-employed',
        selector: 'currentlyEmployedSelector',
        sec: '5',
        name: 'CurrentlyEmployed',
        true: [...workExperienceEmployedPaths('FullTime')],
        false: [...workExperienceUnemployedAndFullTimeCoursePaths()],
      },
    ],
    noExperienceFullTime: [...confirmedJobOfferPaths()],
    stateItemsToReset: [
      'employer',
      'employerCountry',
      'employmentDates',
      'currentlyEmployed',
      'currentSalaryAmount',
      'employerOfficeCountryCode',
      'employmentDatesEndMonth',
      'employmentDatesEndYear',
      'employmentDatesStartMonth',
      'employmentDatesStartYear',
      'currentSalary',
    ],
  },
  {
    url: '/save-employment',
    type: 'save',
    sec: '5',
    name: 'SaveEmployment',
  },
  {
    url: '/loan-context',
    type: 'newSection',
    sec: '6',
    name: 'LoanContext',
    zendeskSuggestions: ['contextual: onboarding_loan_structure'],
    selector: 'isFirstPeriodSelector',
    true: [],
    false: [
      {
        url: '/previous-prodigy-loan',
        sec: '6',
        name: 'PreviousProdigyLoan',
        selector: 'hasPreviousProdigyLoanSelector',
        true: [
          {
            url: '/previous-prodigy-loan-amount',
            sec: '6',
            name: 'PreviousProdigyLoanAmount',
          },
        ],
        false: [],
      },
    ],
  },
  {
    url: '/other-funds',
    type: 'fetchCapOnLoan',
    sec: '6',
    name: 'OtherFunds',
    selector: 'fundsRequiredSelector',
    true: [{ url: '/deposit', sec: '6', name: 'Deposit' }],
    false: [],
  },
  {
    url: '/loan-amount',
    sec: '6',
    name: 'LoanAmount',
    zendeskSuggestions: ['contextual: onboarding_loan_amount'],
    selector: 'hasMorePeriodsSelector',
    true: [
      {
        url: '/remaining-periods',
        sec: '6',
        name: 'RemainingLoanAmount',
        zendeskSuggestions: ['contextual: onboarding_loan_amount'],
      },
    ],
    false: [],
  },
  {
    url: '/declaration',
    sec: '6',
    name: 'Declaration',
  },
  {
    url: '/save-loan-details',
    type: 'save',
    sec: '6',
    name: 'SaveLoanDetails',
  },
  { url: '/submit', sec: '7', name: 'Submit' },
  { url: '/successful-submission', sec: '7', name: 'SubmitSuccess' },
];

export default wizardConfig;
